// Silent promo-code capture.
// Distribution model: share URLs like `/premium?promo=BEGIN10`.
// When a user lands on any page with `?promo=XXX`, we silently persist the
// code to localStorage. `useRazorpay` forwards it on every `/payment/create-order`
// request; the backend is the sole source of truth for valid codes & percent-off.
// Nothing about the promo system is surfaced in the UI.

const KEY = 'today_promo_code';

export function capturePromoFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('promo');
    if (code && code.trim()) {
      localStorage.setItem(KEY, code.trim().toUpperCase());
    }
  } catch (_) {
    /* ignore */
  }
}

export function getStoredPromo() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(KEY) || null;
  } catch (_) {
    return null;
  }
}

export function clearStoredPromo() {
  if (typeof window === 'undefined') return;
  try { localStorage.removeItem(KEY); } catch (_) { /* ignore */ }
}
